import AccountingClubFee from '../dto/AccountingClubFee.js';
import ClubFee from '../dto/ClubFee.js';
import Error from '../model/Error.js';
import axios from 'axios';

export default class ClubFeeRepository {

    static findByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/club-fees`)
                .then(response => resolve(response.data.data.map(clubFee => AccountingClubFee.fromData(clubFee))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findByIdForAccounting(clubFeeId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/club-fees/${clubFeeId}`)
                .then(response => resolve(AccountingClubFee.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findByClubForAccounting(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/club-fees`)
                .then(response => resolve(response.data.data.map(clubFee => AccountingClubFee.fromData(clubFee))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findByClubIdExcludeArchivedAndSalesList(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/club-fees?excludeArchived=true&excludeSalesList=true`)
                .then(response => resolve(response.data.data.map(data => ClubFee.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(clubFeeId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/club-fees/${clubFeeId}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static archive(clubFee) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/club/club-fees/${clubFee.id}/archived`, { archived: clubFee.isArchived })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static create(clubId, data) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/club-fees`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubFeeId, data) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/club-fees/${clubFeeId}`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
